import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { organizationsKeys } from 'app/queries/organizations/organizationsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.invitationsList>>;

export const createFetchInvitationsQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ organizationId, params }], signal }: TParams) =>
    (await call(() =>
      cancelOnSignal(OrganizationsService.getWsInvitations({ oid: organizationId, search: params.search }), signal),
    )) ?? [];
